import { onMounted, ref } from 'vue'

/**
 * 客户端已挂载（水合完成）。用于 Teleport / 按视口分叉的 DOM，避免 SSR 与首帧不一致。
 */
export function useClientMounted() {
  const isClientMounted = ref(false)

  onMounted(() => {
    isClientMounted.value = true
  })

  return { isClientMounted }
}
